// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3g2dc","dragIcon":"Choice_dragIcon__1UPOa","left":"Choice_left__Hs-_7","input":"Choice_input__2J3Mq"};